import CitySEOHead from "@/components/feature/CitySEOHead";
import BloomingtonHeroSection from "@/pages/bloomington/components/HeroSection";
import BloomingtonStickyNav from "@/pages/bloomington/components/StickyNav";
import BloomingtonProcessingTimeSection from "@/pages/bloomington/components/ProcessingTimeSection";
import BloomingtonServicesSection from "@/pages/bloomington/components/ServicesSection";
import BloomingtonLocalAreaSection from "@/pages/bloomington/components/LocalAreaSection";
import BloomingtonTravelTimingSection from "@/pages/bloomington/components/TravelTimingSection";
import BloomingtonDestinationsSection from "@/pages/bloomington/components/DestinationsSection";
import BloomingtonTestimonialsSection from "@/pages/bloomington/components/TestimonialsSection";
import BloomingtonAcceptanceFacilitiesSection from "@/pages/bloomington/components/AcceptanceFacilitiesSection";
import BloomingtonComparisonSection from "@/pages/bloomington/components/ComparisonSection";
import BloomingtonMistakesSection from "@/pages/bloomington/components/MistakesSection";
import BloomingtonHowItWorksSection from "@/pages/bloomington/components/HowItWorksSection";
import BloomingtonFAQSection from "@/pages/bloomington/components/FAQSection";
import BloomingtonHelpfulResourcesSection from "@/pages/bloomington/components/HelpfulResourcesSection";
import BloomingtonFinalCTA from "@/pages/bloomington/components/FinalCTA";

const pageTitle = "Emergency Passport Bloomington, MN — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency & expedited passport services in Bloomington, MN. As fast as 24 hours. Serving Mall of America families, MSP Airport travelers, and Best Buy corporate employees. A+ BBB rated registered State Dept. courier. Best price guarantee.";
const bloomingtonFaqs = [
  { q: "How fast can I get a passport in Bloomington, MN?", a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select." },
  { q: "Can I get a passport fast near the Mall of America?", a: "Yes. We regularly process expedited renewals and new applications for Bloomington families with compressed timelines — as fast as 2–9 business days." },
];

export default function BloomingtonPage() {
  return (
    <>
      <CitySEOHead
        city="Bloomington"
        state="Minnesota"
        stateAbbr="MN"
        route="/cities/bloomington"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Bloomington, Minnesota"
        geoPosition="44.8408;-93.2983"
        keywords="expedited passport Bloomington, emergency passport Bloomington MN, Mall of America passport, MSP Airport passport, fast passport Minnesota, Bloomington passport office"
        faqs={bloomingtonFaqs}
        servicesSchema={[]}
        statePageName="Minnesota"
        statePageRoute="/states/minnesota"
        lastModified="2026-06-14"
        areaServedList={[
          { "@type": "City", name: "Bloomington" },
          { "@type": "City", name: "Edina" },
          { "@type": "City", name: "Richfield" },
          { "@type": "City", name: "Minneapolis" },
          { "@type": "City", name: "Eagan" },
          { "@type": "City", name: "Burnsville" },
          { "@type": "AdminArea", name: "Hennepin County" },
        ]}
        serviceAreaDesc="Emergency & expedited passport services for Bloomington, MN residents. Registered U.S. Department of State courier. A+ BBB rated. As fast as 24 hours."
      />

      <div className="min-h-screen bg-white">
        <BloomingtonHeroSection />
        <BloomingtonStickyNav />
        <BloomingtonProcessingTimeSection />
        <BloomingtonServicesSection />
        <BloomingtonLocalAreaSection />
        <BloomingtonTravelTimingSection />
        <BloomingtonDestinationsSection />
        <BloomingtonTestimonialsSection />
        <BloomingtonAcceptanceFacilitiesSection />
        <BloomingtonComparisonSection />
        <BloomingtonMistakesSection />
        <BloomingtonHowItWorksSection />
        <BloomingtonFAQSection />
        <BloomingtonHelpfulResourcesSection />
        <BloomingtonFinalCTA />
      </div>
    </>
  );
}